import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/authentication-service/authentication.service';



/**
 * Angular guard function that checks if the user is NOT logged in.
 *
 * If yes, the user is redirected to the tracker page.
 *
 * This guard is used to prevent logged in users from accessing the login page.
 *
 * @param route Standard route
 * @param state
 * @returns
 */
export const anonymousGuard: CanActivateFn = () => {
  const authSrvc = inject(AuthenticationService);
  const router = inject(Router);

  if (authSrvc.isUserLoggedIn()) {
    // Redirect to the tracker page
    return router.parseUrl('/tracker-page');
  }
  return true;
};
